import {
	Dtos,
	SuretyAccountId,
	type SuretyQuoteId,
	type SuretyQuoteUnderwritingStatus,
	type UserId,
} from "@inrev/common";
import { createContext, useContext } from "react";
import type { buildCreateQuotePayload } from "./steps/buildCreateQuotePayload";

type OutcomeQueryResult = {
	bondRequest?: { underwritingStatus?: SuretyQuoteUnderwritingStatus } | null;
};

export type AgentOption = { label: string; value: UserId };

export type BondRequestSubmissionCompany =
	| Dtos.Company.Get.Response
	| Dtos.Admin.SuretyAccount.Get.Response.Company;

export type BondRequestSubmissionAdapter = {
	submitBondRequest: (
		payload: ReturnType<typeof buildCreateQuotePayload>,
		opts: {
			accountId?: SuretyAccountId;
			agentId?: UserId;
			onSuccess: (id: SuretyQuoteId) => void;
			onError: () => void;
		},
	) => void;
	useOutcomeQuery: (id: SuretyQuoteId) => OutcomeQueryResult;
	companies: BondRequestSubmissionCompany[] | undefined;
	companiesIsLoading: boolean;
};

const BondRequestSubmissionAdapterContext = createContext<BondRequestSubmissionAdapter | null>(
	null,
);

export const BondRequestSubmissionAdapterProvider = BondRequestSubmissionAdapterContext.Provider;

export const useBondRequestSubmissionAdapter = (): BondRequestSubmissionAdapter => {
	const ctx = useContext(BondRequestSubmissionAdapterContext);
	if (!ctx)
		throw new Error(
			"useBondRequestSubmissionAdapter must be used within a BondRequestSubmissionAdapterProvider",
		);
	return ctx;
};
